<template>
  <v-card class="ma-0 px-1" width="100%" flat>
    <v-app-bar flat class="my-0 mb-2 py-1 px-4" dense height="30">
      <v-toolbar-title>{{ $t($route.name) }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo(typeForm)"
          >
            <v-icon color="teal" style="font-size: 22px"> mdi-plus-box-outline </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(typeForm) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon small v-on="on" @click="goTo(typeForm + 'List')">
            <v-icon color="primary" style="font-size: 22px">
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(typeForm + "List") }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" icon small v-on="on" @click="$router.go(-1)">
            <v-icon color="primary" style="font-size: 22px"> mdi-arrow-left </v-icon>
          </v-btn>
        </template>
        <span>{{ $t("back") }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form v-if="render" ref="form" v-model="valid" lazy-validation>
      <v-tabs>
        <v-tab style="height: 50px">
          {{ $t("public-information") }}
        </v-tab>
        <v-tab :disabled="!documentPermmission">
          {{ $t("documents") }}
        </v-tab>
        <v-tab-item>
          <v-container>
            <v-row>
              <v-col class="px-3 xs" cols="12" md="3" sm="6">
                <autocomplete
                  v-model="detail"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :title="$t(typeForm)"
                  type="alldetail"
                  :value="detail"
                />
              </v-col>
              <v-col class="px-3 xs" cols="12" md="3" sm="6">
                <autocomplete
                  v-model="account"
                  title="account"
                  type="person"
                  :new-btn="true"
                  :value="account"
                />
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <autocomplete
                  v-model="currency"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :title="$t('currency')"
                  type="currency"
                  :init="defaultCurrency"
                  :value="currency"
                  @change="changeCurrency"
                />
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <money
                  v-model="price"
                  :label="$t('amount')"
                  :dense="true"
                  :outlined="true"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  @input="checkPrice"
                />
              </v-col>
              <v-col cols="12" sm="2" md="2">
                <money
                  v-model="currency_amount"
                  :label="$t('currency-rate')"
                  :dense="true"
                  :outlined="true"
                  :rules="[(v) => !!v || $t('is-required')]"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                />
              </v-col>
              <v-col cols="12" md="3" sm="6">
                <template>
                  <v-text-field
                    id="from"
                    v-model="date"
                    :label="$t('date')"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    clearable
                  />

                  <date-picker
                    v-model="date"
                    element="from"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="$store.state.startDate"
                    :max="$store.state.endDate"
                    :color="
                      this.$vuetify.theme.themes[
                        this.$vuetify.theme.isDark ? 'dark' : 'light'
                      ].primary
                    "
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col cols="12" md="3">
                <tag v-model="tag" :solo="false" :input="tag" />
              </v-col>
              <v-col cols="9" md="2">
                <autocomplete
                  ref="refBank"
                  v-model="bank"
                  :rules="bankRule"
                  :title="$t('bank') + '/' + $t('cash')"
                  :currency-prop="currency ? currency.id : null"
                  type="bankCash"
                />
              </v-col>
              <!--          <v-col-->
              <!--            v-if="bank"-->
              <!--            class="px-3 xs pb-0"-->
              <!--            cols="12"-->
              <!--            md="2"-->
              <!--            sm="6"-->
              <!--          >-->
              <!--            <v-chip-->
              <!--              class="mx-0"-->
              <!--              :color="bankRemainColor"-->
              <!--              label-->
              <!--              style="width: 100%"-->
              <!--              outlined-->
              <!--            >-->
              <!--              {{ $t('remain') }}   {{ $t('bank') + '/' + $t('cash') }} : {{ $numberFormat(parseFloat(bankRemain)) }} {{ (currency ? currency.name : '') }}-->
              <!--            </v-chip>-->
              <!--          </v-col>-->
              <!--          <v-col-->
              <!--            class="px-3 xs"-->
              <!--            cols="12"-->
              <!--            md="2"-->
              <!--          >-->
              <!--            <autocomplete-->
              <!--              v-model="plan"-->
              <!--              :title="$t('plan')"-->
              <!--              type="plan"-->
              <!--              :value="plan"-->
              <!--              :data="JSON.stringify({type:'sale'})"-->
              <!--              :set-init="true"-->
              <!--            />-->
              <!--          </v-col>-->
              <v-col v-if="payItems && payItems.length > 0" cols="3" md="3">
                <v-chip
                  v-for="(item, key) in payItems"
                  :key="key"
                  class="ma-2"
                  :close="item.chip"
                  :color="item.chip ? item.color : 'grey'"
                  outlined
                  @click:close="item.chip = false"
                >
                  <v-icon v-if="!item.chip" color="green" @click="item.chip = true">
                    mdi-refresh
                  </v-icon>
                  {{ item.type == "pay_naghd" ? $t("cashPay") : "" }}
                  - {{ $t("price") }} : {{ $numberFormat(parseFloat(item.amount)) }}
                </v-chip>
              </v-col>
              <v-col v-if="typeForm !== 'commission' && typeForm !== 'penalty'" md="1">
                <v-checkbox
                  v-model="taxFeilds"
                  class="mt-0"
                  hide-details
                  :label="$t('tax')"
                />
              </v-col>
              <v-col
                v-if="account && typeForm !== 'commission' && typeForm !== 'penalty'"
                md="1"
              >
                <v-checkbox
                  v-model="refundStatus"
                  class="mt-0"
                  hide-details
                  :label="$t('refund')"
                />
              </v-col>
              <v-col v-if="refundStatus && account" cols="12" md="2">
                <money
                  v-model="refund"
                  :label="$t('refundAmount')"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                />
              </v-col>
              <v-col v-if="typeForm !== 'commission' && typeForm !== 'penalty'" md="1">
                <v-checkbox
                  v-model="discountFeilds"
                  class="mt-0"
                  hide-details
                  :disabled="this.taxStatus === 'notAdd' ? true : false"
                  :label="$t('discount')"
                />
              </v-col>
            </v-row>
            <v-row v-if="taxFeilds">
              <v-col cols="4" sm="2" md="2">
                <vuetify-money
                  v-model="tax"
                  :label="$t('tax')"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="optionsTax"
                />
              </v-col>
              <v-col cols="8" sm="2" md="2">
                <vuetify-money
                  v-model="taxAmount"
                  :label="$t('amount') + ' ' + $t('tax')"
                  :dense="true"
                  :disabled="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                />
              </v-col>
              <v-col cols="12" md="4">
                <v-select
                  v-model="taxStatus"
                  :label="$t('taxStatus')"
                  :items="taxStatusItems"
                  height="30"
                  dense
                  outlined
                  item-value="value"
                  item-text="text"
                />
              </v-col>
            </v-row>
            <v-row v-if="discountFeilds">
              <v-col cols="12" sm="6" md="3">
                <vuetify-money
                  v-model="discount"
                  :label="$t('discount')"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :options="options"
                  :value-options="{ max: price }"
                  @SetValueMax="SetValueMaxDiscount()"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="3" md="3">
                <autocomplete
                  v-model="branch"
                  :title="$t('branch')"
                  type="branch"
                  :set-init="true"
                  :value="branch"
                />
              </v-col>
              <v-col cols="12" sm="3" md="3">
                <autocomplete
                  v-model="costGiven"
                  :title="$t('given') + ' ' + $t(typeForm)"
                  type="given"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <description
                  ref="refDescription"
                  v-model="description"
                  :outlined="true"
                  :value="description"
                  type="sell"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-chip v-if="taxAmount" label dark outlined color="orange">
                  {{ $t("Net-fee") }} : {{ $numberFormat(NetPrice) }}
                </v-chip>
                <v-chip v-if="taxAmount" label dark outlined class="mx-1" color="green">
                  {{ $t("tax") }} : {{ $numberFormat(taxAmount) }}
                </v-chip>
                <v-chip v-if="discount" label dark outlined class="mx-1" color="pink">
                  {{ $t("discount") }} : {{ $numberFormat(discount) }}
                </v-chip>
                <v-chip label dark outlined class="mx-1" color="blue">
                  {{ $t("sum") }} : {{ $numberFormat(sum) }}
                </v-chip>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 pt-2">
            <v-col cols="12" md="3" sm="3">
              <file-picker
                ref="refFilePicker"
                v-model="attachments"
                :label="$t('addDocuments')"
                :multiple="true"
                type-prop="costIncome"
                :val="id && attachments ? attachments : null"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col cols="6" class="px-1">
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t("submit") }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t("submit") }}
            </v-btn>
          </v-col>
          <v-col cols="6" class="px-2">
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="goTo(typeForm + 'List')"
            >
              {{ $t(typeForm + "List") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <snakbar
      v-model="snakbar"
      :text="snakbarText"
      :active="snakbar"
      :color="snakbarColor ? snakbarColor : 'primary'"
    />
  </v-card>
</template>

<script>
import Description from "../../components/general/description/Description";
import General from "../../../../Mixins/general";
import filePicker from "../../components/general/filePicker/index";
export default {
  name: "Customer",
  components: {
    autocomplete: () => import("../../components/general/patial/autocomplete"),
    Tag: () => import("../../components/general/Tag/tag"),
    Snakbar: () => import("../../components/general/snakbar/snakbar"),
    filePicker,
    Description,
  },
  mixins: [General],
  props: ["type", "refId"],
  data: () => ({
    extra: false,
    valid: true,
    attachments: null,
    id: null,
    ref_type: null,
    ref_id: null,
    refundStatus: false,
    refund: 0,
    costGiven: null,
    currency: null,
    currency_amount: 1,
    tag: null,
    customerId: null,
    defaultCurrency: null,
    taxStatus: null,
    typeForm: "cost",
    taxStatusItems: null,
    clearing: null,
    snackbarShow: null,
    payed: 0,
    payItems: [],
    price: 0,
    NetPrice: 0,
    NetPriceEdit: 0,
    taxAmount: 0,
    tax: 9,
    discount: 0,
    plan: null,
    taxFeilds: null,
    discountFeilds: null,
    account: null,
    options: {
      locale: "en-US",
      prefix: "",
      suffix: "  ",
      precision: 0,
    },
    optionsTax: {
      locale: "en-US",
      prefix: "",
      suffix: "  %  ",
      precision: 0,
    },
    detail: null,
    editPrice: 0,
    bank: null,
    description: null,
    date: null,
    render: true,
    isLoading: false,
    showing: false,
  }),
  computed: {
    bankRule() {
      const rules = [];
      if (!this.account) {
        const rule = (v) => !!v || this.$t("is-required");
        rules.push(rule);
      }

      return rules;
    },
    sum() {
      if (this.taxStatus === "notAdd") {
        return parseFloat(this.price) - parseFloat(this.discount);
      } else {
        return (
          parseFloat(this.price) - parseFloat(this.discount) + parseFloat(this.taxAmount)
        );
      }
    },
  },
  watch: {
    defaultCurrency() {
      if (this.defaultCurrency) {
        this.currency = this.defaultCurrency;
        this.currency_amount = this.defaultCurrency.amount;
      }
    },
    tax() {
      this.calculateTax();
    },
    taxFeilds() {
      this.calculateTax();
    },
    discount() {
      this.calculateTax();
    },
    bank() {
      if (this.bank && this.typeForm === "cost") {
        this.remainBank(this.price);
      }
    },
    price() {
      this.calculateTax();
    },
    taxStatus() {
      this.calculateTax();
    },
    currency(val, old) {
      if (val) {
        if (this.render && !this.showing) {
          this.currency_amount = val.amount;
          this.bank = null;
        }
      } else {
        this.currency_amount = null;
      }
      this.showing = false;
    },
    type() {
      this.typeForm = this.type;
    },
  },
  beforeMount() {
    this.typeForm = this.$route.name;
    if (this.type) {
      this.typeForm = this.type;
    }
    if (!this.type && this.$route.params.id != null) {
      this.id = this.$route.params.id;
      this.render = false;
      this.clearForm();
      this.show();
    } else {
      this.currency = JSON.parse(localStorage.getItem("token")).init.currency;
      this.render = true;
      this.defaultCurrency = this.getDefault("defaultCurrency");
    }
  },
  mounted() {
    this.taxStatusItems = [
      {
        value: "add",
        text: this.$t("add-tax-to-price"),
      },
      {
        value: "notAdd",
        text: this.$t("calculate-tax-on-price"),
      },
    ];
    this.taxStatus = "notAdd";
  },
  methods: {
    remainBank(price = 0) {
      if (this.bank && this.bank.remain !== undefined) {
        // if (this.$route.params.id != null) {
        //   this.bankRemain = parseFloat(this.bank.remain.currency_remain) - parseFloat(price) + parseFloat(this.editPrice)
        // } else {
        //   this.bankRemain = parseFloat(this.bank.remain.currency_remain) - parseFloat(price)
        // }
        //
        // this.bankRemainColor = 'grey'
        // if (this.bankRemain > 0) {
        //   this.bankRemainColor = 'green'
        // }
        // if (this.bankRemain < 0) {
        //   this.bankRemainColor = 'pink'
        // }
        // if (this.bank && parseFloat(price) > parseFloat(this.bank.remain.currency_remain) + parseFloat(this.editPrice)) {
        //   this.price = 0
        //   this.bankRemain = parseFloat(this.bank.remain.currency_remain) - parseFloat(price) + parseFloat(this.editPrice)
        //   this.snakbarText = this.$t('alert-pay-amount-bigger-than-bank-remain')
        //   this.snakbarColor = 'pink'
        //   this.snakbar = true
        // }
      }
    },
    checkPrice() {
      if (this.taxFeilds) {
        this.calculateTax();
      }
      if (this.bank && this.typeForm === "cost") {
        // this.remainBank(this.price)
      }
    },
    changeCurrency() {
      this.bankRemain = 0;
      this.currency_amount = this.currency.amount;
      this.options = {
        locale: "en-US",
        prefix: "",
        suffix: this.currency.name,
        precision: this.currency.decimal,
      };
    },
    SetValueMaxPrice() {
      if (this.clearing) {
        this.price = this.bankRemain;
      }
    },
    SetValueMaxDiscount() {
      this.discount = this.price;
    },
    create() {
      // if (parseFloat(this.bankRemain) < 0) {
      //   this.snakbarText = this.$t('alert-pay-amount-bigger-than-bank-remain')
      //   this.snakbarColor = 'pink'
      //   this.snakbar = true
      //   return false
      // }
      if (!this.$refs.form.validate()) return false;
      var app = this;
      app.isLoading = true;
      app.$axios
        .post(this.$endpoint + "CostIncome", this.$data)
        .then((res) => {
          var result = res.data.data;
          app.snakbarText = app.$t("registered");
          app.snakbarColor = "green";
          app.snakbar = true;
          app.$emit("close", app.$route);
          if (app.$refs.refFilePicker !== undefined && app.attachments) {
            app.$refs.refFilePicker.create(result.id);
          }
          if (app.refId) {
            var data = {
              name: app.detail.name,
              amount:
                (parseFloat(result.price) + parseFloat(result.tax)) *
                result.currency_amount,
              id: result.id,
            };
            app.$emit("input", data);
          } else {
            app.goTo(app.typeForm + "List");
          }
          this.clearForm();
        })
        .catch((err) => {
          if (err.response && err.response.status === 409) {
            this.$store.commit("SET_PLAN_DIALOG", true);
          }
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    show() {
      var app = this;
      app.loading = true;
      app.clearing = true;
      app.showing = true;
      app.$axios
        .get(this.$endpoint + "CostIncome/" + this.$route.params.id + "/edit", {
          params: {
            id: this.$route.params.id,
          },
        })
        .then((res) => {
          res = res.data;
          app.typeForm = res.type;
          app.id = res.id;
          app.price = res.price;
          app.NetPriceEdit = res.price;
          app.attachments = res.attachments;
          app.editPrice = res.price;
          app.account = res.customer;
          app.branch = res.branch;
          app.costGiven = res.given;
          app.currency_amount = res.currency_amount;
          app.currency = res.currency;
          app.date = res.date;
          app.plan = res.plan ? res.plan.plan : null;
          app.detail = res.account;
          app.refund = res.refund;
          app.ref_type = res.ref_type;
          app.ref_id = res.ref_id;
          if (app.refund && app.refund > 0) {
            app.refundStatus = true;
          }
          if (res.tags) {
            app.tag = res.tags;
            app.more = true;
          }
          app.taxAmount = res.tax;
          if (app.taxAmount && app.taxAmount > 0) {
            app.taxStatus = app.taxStatusItems[0];
            app.taxFeilds = true;
            setTimeout(function () {
              app.taxAmount = res.tax;
            }, 1000);
          }
          app.discount = res.discount;
          app.bank = res.bank;
          if (app.discount && app.discount > 0) {
            app.discountFeilds = true;
          }
          app.payed = parseFloat(app.price) - parseFloat(res.remain);
          app.payItems = res.relations;
          app.description = res.description;
          // app.$refs.refDescription.setData(res.description)
          // setTimeout(function () {
          //   app.showing = false
          //   app.render = true
          // }, 500)
          app.render = true;
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.loading = false));
    },
    update() {
      var app = this;
      if (!this.$refs.form.validate()) return false;
      app.isLoading = true;
      app.$axios
        .put(this.$endpoint + "CostIncome/" + this.$route.params.id, this.$data)
        .then((res) => {
          res = res.data;
          if (app.$refs.refFilePicker !== undefined) {
            app.$refs.refFilePicker.create(res.data.id);
          }
          app.$emit("close", app.$route);
          app.goTo(app.typeForm + "List");
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => (app.isLoading = false));
    },
    calculateTax() {
      if (!this.showing && this.taxFeilds) {
        if (this.taxStatus === "notAdd") {
          this.discountFeilds = null;
          this.discount = 0;
          var price = (parseFloat(this.price) * 100) / (100 + parseInt(this.tax));
          this.taxAmount = parseInt(this.price) - parseInt(price);
          this.NetPrice =
            this.price - this.taxAmount.toFixed(this.$store.state.currency.decimal);
        } else {
          this.taxAmount = (
            (parseFloat(this.price) -
              parseFloat(this.refund) -
              parseFloat(this.discount)) *
            (this.tax / 100)
          ).toFixed(this.$store.state.currency.decimal);
          this.NetPrice = this.price;
        }
      } else {
        this.taxAmount = 0;
        this.NetPrice = this.price;
      }
    },
    clearForm() {
      this.extra = false;
      this.attachments = null;
      this.id = null;
      this.costGiven = null;
      this.tag = null;
      this.customerId = null;
      this.taxStatus = null;
      this.taxStatusItems = null;
      this.clearing = null;
      this.snackbarShow = null;
      this.payed = 0;
      this.price = 0;
      this.NetPrice = 0;
      this.taxAmount = 0;
      this.tax = 9;
      this.discount = 0;
      this.taxFeilds = null;
      this.discountFeilds = null;
      this.account = null;
      this.detail = null;
      this.editPrice = null;
      this.bank = null;
      this.description = null;
    },
  },
};
</script>

<style scoped>
.col {
  height: 55px !important;
}
</style>
